import { citiboxColors } from '../../theme/index';

export interface CitiboxLogoProps {
  /** Rendered width and height in px — the mark is square. Defaults to 28. */
  size?: number;
  /** Accessible name announced by screen readers. Defaults to "Citibox". */
  title?: string;
}

// The Citibox brandmark (Figma "CDS | Users — Foundations", node 301:2441): a rounded
// square in brand purple with the white "loop" glyph. The purple is the primary brand
// token; the cropped Figma frame backdrop from the export is intentionally omitted. The
// 113.387 viewBox units are the asset's native coordinates — the paths are authored in them.
export function CitiboxLogo({ size = 28, title = 'Citibox' }: CitiboxLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 113.387 113.387"
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="113.387" height="113.387" rx="21" fill={citiboxColors.primary} />
      <path
        d="M20.779 72.7614C23.5304 79.2564 29.0226 79.8919 32.0772 77.173C35.1317 74.4541 36.029 71.3712 33.6855 66.3082C31.3423 61.2447 30.5066 52.0027 34.703 44.8815C36.8896 40.9086 40.5523 36.9023 45.2571 34.4864C49.9619 32.0705 58.0271 30.2106 66.2279 33.5698C72.2044 36.0172 75.4216 35.7327 78.5042 32.4878C81.5869 29.243 79.5319 23.6187 73.4235 21.0394C67.3149 18.4601 63.3304 17.3569 56.6459 17.3511C49.6129 17.3569 42.9304 19.0132 37.0425 22.5377C31.1547 26.0622 26.2151 30.8625 22.8619 36.4694C19.509 42.0759 17.1406 50.4012 17.3575 56.8346C17.5744 63.2684 18.0277 66.266 20.779 72.7614Z"
        fill="#fff"
      />
      <path
        d="M92.6073 40.6256C89.856 34.1306 84.3637 33.4951 81.3091 36.214C78.2546 38.9329 77.3573 42.0158 79.7008 47.0788C82.044 52.1423 82.8797 61.3843 78.6833 68.5055C76.4967 72.4784 72.8341 76.4847 68.1292 78.9006C63.4244 81.3165 55.3592 83.1764 47.1585 79.8172C41.1819 77.3698 37.9648 77.6543 34.8821 80.8991C31.7994 84.144 33.8545 89.7683 39.9628 92.3476C46.0714 94.9268 50.0559 96.0301 56.7404 96.0359C63.7734 96.0301 70.456 94.3738 76.3438 90.8493C82.2316 87.3248 87.1713 82.5245 90.5244 76.9175C93.8773 71.3111 96.2457 62.9858 96.0288 56.5524C95.8119 50.1186 95.3587 47.121 92.6073 40.6256Z"
        fill="#fff"
      />
    </svg>
  );
}
